module.exports = __webpack_public_path__ + "static/scale-model-of-happy-hollow-park-&-zoo-in-san-jose-california-146e957f0b1a019322d41ddd7bcd2192.png";